var _g, _line, _rect, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    transform: "translate(8 8)",
    stroke: "#3c4347",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_14421",
    "data-name": "Line 14421",
    x2: 4,
    y2: 4,
    transform: "translate(19 19)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.154
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1636",
    "data-name": "Rectangle 1636",
    width: 32,
    height: 32,
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_14561",
    "data-name": "Line 14561",
    x2: 4,
    transform: "translate(12.5 14.5)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_14562",
    "data-name": "Line 14562",
    y2: 4,
    transform: "translate(14.5 12.5)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.47a315d3d024eff05b4f3f232ccbac22.svg";
export { ForwardRef as ReactComponent };